import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router'
import { Icon, type IconName } from '../components/primitives'
import { SearchBox } from '../components/Search'
import { ThemeSeg } from '../components/ThemeToggle'
import { SiteFooter } from '../components/Disclosures'

// PodcastAlpha.html: sidebar navigation and a search box above every page.

const ITEMS: { to: string; label: string; icon: IconName; owns: (p: string) => boolean }[] = [
  { to: '/', label: 'Recommendations', icon: 'rec', owns: (p) => p === '/' || p.startsWith('/rec/') },
  { to: '/stocks', label: 'Stocks', icon: 'stock', owns: (p) => p.startsWith('/stocks') },
  { to: '/podcasts', label: 'Podcasts', icon: 'podcast', owns: (p) => p.startsWith('/podcasts') },
  { to: '/episodes', label: 'Episodes', icon: 'episode', owns: (p) => p.startsWith('/episodes') },
]

export function DesktopShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  return (
    <div className="app" data-layout="desktop">
      <aside className="side">
        <Link to="/" className="brand" style={{ color: 'inherit', textDecoration: 'none' }}>
          <span className="dot" />
          PodcastAlpha
        </Link>
        <nav className="nav-group" aria-label="Browse">
          <div className="label">Browse</div>
          {ITEMS.map((it) => {
            const active = it.owns(pathname)
            return (
              <Link key={it.to} to={it.to} className={`nav-item ${active ? 'active' : ''}`} aria-current={active ? 'page' : undefined}>
                <span className="ico"><Icon name={it.icon} /></span>
                {it.label}
              </Link>
            )
          })}
        </nav>
        <div className="nav-group side-foot">
          <div className="label">Appearance</div>
          <ThemeSeg />
        </div>
      </aside>
      <main className="main">
        <div className="page-top">
          <span className="grow" />
          <SearchBox />
        </div>
        {children}
        <SiteFooter />
      </main>
    </div>
  )
}
